import { sortByName } from './sortUser';

export function sortByUserName(a, b) {
    return sortByName(a.user, b.user);
}

export function sortByClientThenStart(a, b, reverseSubsort = false) {
    return sortByClientDateName('start_date', a, b, reverseSubsort);
}

export function sortByClientThenEnd(a, b, reverseSubsort = false) {
    return sortByClientDateName('end_date', a, b, reverseSubsort);
}

export function sortByStartDateThenName(a, b, reverseSubsort = false) {
    return sortByDateThenName('start_date', a, b, reverseSubsort);
}

export function sortByEndDateThenName(a, b, reverseSubsort = false) {
    return sortByDateThenName('end_date', a, b, reverseSubsort);
}

function sortByClientDateName(dateField, a, b, reverseSubsort = false) {
    if (a.client_name !== b.client_name) {
        return a.client_name.localeCompare(b.client_name);
    }

    if (a[dateField] !== b[dateField]) {
        const dateCompare = a[dateField] > b[dateField] ? 1 : -1;
        return reverseSubsort ? -dateCompare : dateCompare;
    }

    return reverseSubsort ? sortByUserName(b, a) : sortByUserName(a, b);
}

function sortByDateThenName(dateField, a, b, reverseSubsort = false) {
    if (a[dateField] !== b[dateField]) {
        return a[dateField] > b[dateField] ? 1 : -1;
    }
    return reverseSubsort ? sortByUserName(b, a) : sortByUserName(a, b);
}



// WEBPACK FOOTER //
// ./src/utilities/sortJobExt.jsx